// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const ConversationConstants = Marty.createConstants([
  'RECENT_END_USER_CONVERSATIONS_FETCH',
  'CONVERSATION_BLOCKS_FETCH',
  'CONVERSATIONS_BY_ID_FETCH',
  'LOAD_MORE_CONVERSATION_GROUPS',
  'CONVERSATION_FETCH',
  'CONVERSATIONS_COUNT_FETCH',
  'OPEN_CONVERSATIONS_FETCH',
  'MESSAGE_CREATE',
  'UPDATE_CONVERSATION',
  'PUSHER_CONVERSATION',
  'SEARCH_ALL_CONVERSATIONS'
])

ConversationConstants.COMPOSER_ELEMENT_ID = 'textAreaComponent'

export default ConversationConstants



// WEBPACK FOOTER //
// ./src/scripts/constants/ConversationConstants.js